import type { DataFieldValue } from "@huub-web/ui/types/DataFieldValue";
import { useDebug } from "@huub-web/ui";

import { useAPI } from "./useAPI";

/**
 * Hook for updating key-value data.
 * @returns The key-value data API methods.
 */
export const useDataFieldAPI = () => {
  const { $post } = useAPI();
  const { log } = useDebug();

  const updateValue = (
    endpoint: string,
    value: DataFieldValue,
    linkedValues?: Record<string, DataFieldValue>,
  ) => {
    log("orange", "useDataFieldAPI", "updateValue", endpoint, value);

    const body: Record<string, unknown> = { value };
    if (linkedValues) {
      body.linked_values = linkedValues;
    }

    return $post(endpoint, body);
  };

  return { updateValue };
};
